import { ReleaseEnvironment } from "./release-environment";
import { Variable } from "./variable";

export class HistoryDocument {
  name!: string;
  modifiedBy?: string;
  comment?: string;
  modifiedDate?: string;
  variables: Variable[] = [];
  revision?: number;
  environments: ReleaseEnvironment[] = [];
}